var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManoPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 28C44 32.2435 42.3143 36.3131 39.3137 39.3137C36.3131 42.3143 32.2435 44 28 44M36 22V20C36 18.9391 35.5786 17.9217 34.8284 17.1716C34.0783 16.4214 33.0609 16 32 16C30.9391 16 29.9217 16.4214 29.1716 17.1716C28.4214 17.9217 28 18.9391 28 20V18C28 16.9391 27.5786 15.9217 26.8284 15.1716C26.0783 14.4214 25.0609 14 24 14C22.9391 14 21.9217 14.4214 21.1716 15.1716C20.4214 15.9217 20 16.9391 20 18V20M20 19V8C20 6.93913 19.5786 5.92172 18.8284 5.17157C18.0783 4.42143 17.0609 4 16 4C14.9391 4 13.9217 4.42143 13.1716 5.17157C12.4214 5.92172 12 6.93913 12 8V28",
    stroke: "#7794AC",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0002 22C36.0002 20.9391 36.4216 19.9217 37.1718 19.1716C37.9219 18.4214 38.9393 18 40.0002 18C41.0611 18 42.0785 18.4214 42.8286 19.1716C43.5788 19.9217 44.0002 20.9391 44.0002 22V28C44.0002 32.2435 42.3145 36.3131 39.3139 39.3137C36.3133 42.3143 32.2437 44 28.0002 44H24.0002C18.4002 44 15.0002 42.28 12.0202 39.32L4.82021 32.12C4.13208 31.3579 3.76338 30.3603 3.79045 29.3339C3.81753 28.3074 4.2383 27.3307 4.96565 26.6059C5.69299 25.8811 6.67121 25.4638 7.69775 25.4404C8.72429 25.417 9.72053 25.7892 10.4802 26.48L14.0002 30",
    stroke: "#7794AC",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManoPointer);
export default __webpack_public_path__ + "static/media/Mano_pointer.9ec49b784e1a483f610745adfbffebde.svg";
export { ForwardRef as ReactComponent };